<template>
  <div style="display: inline;">
    <el-form ref="form" size="mini" :model="form" label-width="0px">
      <el-form-item :label="$t('wuliaoBOMmingcheng')" class="noborder" label-width="115px" prop="name" :rules="rules.name">
        <div style="display: flex; align-items: center; justify-content: space-between; padding-right: 100px;">
          <el-input v-model="form.name" type="text" class="input1"></el-input>
          <div style="display: flex; align-items: center;">
            <span style="margin-right: 8px; white-space: nowrap;">{{ $t('sheweimoren' )}}</span>
            <el-switch v-model="form.isDefault"></el-switch>
          </div>
        </div>
      </el-form-item>
      <el-form-item>
        <yi_cross_select :key="key" :selectTitle="'code,name'" ref="material" :component="'web_base_matter_list'" :min="1" :ids.sync="materialList" multiple :isInput="true" :isButton="true" :buttonTitle="'tianjiawuliao'" @getItems="getItems"> </yi_cross_select>
      </el-form-item>
      <el-table class="tables" :data="form.items" :header-cell-style="{ background: '#F5F7FA', color: '#606266', 'font-weight': '700', height: '48px', padding: '0px' }" :show-overflow-tooltip="true" size="mini" border stripe max-height="600">
        <el-table-column prop="materialCode" :label="$t('wuliaobianma')" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <el-form-item :prop="'items.' + scope.$index + '.materialCode'" :rules="rules.materialCode">
              <span>{{ scope.row.materialCode }}</span>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column prop="materialName" :label="$t('wuliaomingcheng')" width="250" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <el-form-item :prop="'items.' + scope.$index + '.materialName'" :rules="rules.materialName">
              <span>{{ scope.row.materialName }}</span>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column prop="ratio" :label="$t('peifangbili')">
          <template slot-scope="scope">
            <el-input-number :precision="2" :step="0.1" v-model="scope.row.ratio" :controls="false" class="input" @blur="changeWeight(scope.row)"> </el-input-number>
          </template>
        </el-table-column>
        <el-table-column prop="weight" :label="$t('peifangyongliaoliang')" :render-header="addRedStar">
          <template slot-scope="scope">
            <el-input-number v-model="scope.row.weight" :precision="3" :controls="false" class="input"> </el-input-number>
          </template>
        </el-table-column>
        <el-table-column prop="weight" :label="$t('morendanwei')">
          <template slot-scope="scope">
            <span>{{$t(store.state.dictJsonAll['UNIT_CONVERSION_TYPE'][scope.row.defaultUnit])}}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('caozuo')" class="caozuo">
          <template slot-scope="scope">
            <span style="color:#F56C6C;font-size: 14px;font-family: Microsoft YaHei UI;" @click="deleteRow(scope.$index, scope.row)">{{ $t('shanchu') }}</span>
          </template>
        </el-table-column>
      </el-table>
    </el-form>
  </div>
</template>

<script>
import add_material from '@@/pages/web/base/matter/add_material';
export default {
  name: 'web_base_matter_matter_add',
  components: {
    add_material
  },
  props: {
    edit: {
      type: Object,
      default: () => ({})
    },
    matterRow: {
      type: Object
    }
  },
  data() {
    return {
      key: 0,
      materialList: [],
      form: {
        name: '',
        items: []
      },
      rules: {
        materialCode: [
          {
            required: true,
            message: this.$t('wuliaobianmabunengweikong'),
            trigger: 'blur'
          }
        ],
        materialName: [
          {
            required: true,
            message: this.$t('wuliaomingchengbunengweikong'),
            trigger: 'blur'
          }
        ],
        ratio: [
          {
            required: true,
            message: this.$t('peifangbili(%)bunengweikong'),
            trigger: 'blur'
          }
        ],
        name: [
          {
            required: true,
            message: this.$t('wuliaobommingchengbunengweikong'),
            trigger: 'blur'
          }
        ]
      }
    };
  },
  created() {
    setTimeout(() => {
      if (this.edit.id) {
        const data = { ...this.edit };
        if (this.edit.items == null) {
          data.items = [];
        } else {
          let items = data.items;
          for (let i = 0; i < items.length; i++) {
            if (items[i] && items[i].weight) {
              items[i].weight = (items[i].weight).toFixed(3);
            }
          }
          data.items = items;
        }

        this.form = data;
      }
    }, 300);
  },
  methods: {
    changeWeight(row) {
      if (!this.matterRow.netWeight) {
        this.matterRow.netWeight = 0;
      }
      if (!row.ratio) {
        row.ratio = 0;
      }
      row.weight = ((row.ratio * this.matterRow.netWeight) / 100).toFixed(3);
    },
    addRedStar(h, { column }) {
      return [h('span', { style: 'color: red' }, '*'), h('span', ' ' + column.label)];
    },
    deleteRow(index, row) {
      this.form.items.splice(index, 1);
    },
    getItems(checks) {
      for (let i = 0; i < checks.length; i++) {
        const res = this.form.items.filter(item => {
          return item.materialId === checks[i]['id'];
        });
        if (res.length > 0) {
          continue;
        }
        const item = {
          materialId: checks[i]['id'],
          materialName: checks[i]['name'],
          materialCode: checks[i]['code'],
          defaultUnit: checks[i]['defaultUnit'],
          weight: checks[i]['weight']
        };
        this.form.items.push(item);
      }
      ++this.key;
      this.materialList = [];
    }
  }
};
</script>

<style scoped lang="scss">
.dialog /deep/ .el-dialog__body {
  overflow: auto;
}

.input /deep/ .el-input__inner {
  width: 120px;
}

.input1 /deep/ .el-input__inner {
  width: 220px;
}
</style>
